// src/services/firebaseService.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
import { getAnalytics } from "firebase/analytics";
import firebaseConfig from '../config/firebaseConfig';

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app); // eslint-disable-line no-unused-vars
const messaging = getMessaging(app);

export const getFcmToken = async (setProcessMessage, setFcmToken, setBrowserNotificationPermission) => {
    if (!('Notification' in window)) {
        console.log('Browser does not support notifications.');
        setBrowserNotificationPermission('unsupported');
        setProcessMessage('❌ Your browser does not support notifications.');
        return null;
    }
    if (Notification.permission !== 'granted') {
        console.log('Browser notification permission not granted. Cannot get FCM token.');
        return null;
    }

    try {
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' });
        console.log('Service Worker registered successfully:', registration);

        const token = await getToken(messaging, {
            vapidKey: 'BJCEhbjnLTRuVeoJleCqdQ-NfKolSncGTaqGcqBGISb-dVUrCwNSzpPCGRCKuMrl3XOJTByOFOP3ZzgNljv7PqA',
            serviceWorkerRegistration: registration
        });
        setFcmToken(token);
        console.log('✅ FCM token obtained:', token);
        return token;
    } catch (err) {
        console.error('❌ Failed to get push notification token:', err);
        setProcessMessage('❌ Failed to get push notification token. Notifications may not work. Check console for errors.');
        setFcmToken(null);
        return null;
    }
};

export { messaging }; // Export messaging instance if needed elsewhere